import { useEffect, useState } from 'react'
import { Mtds } from 'prove-common'
import styles from './GeneratedCodeImage.module.css'

export const GeneratedCodeImage = ({
  id,
  title,
  code,
  url
}: {
  id: string
  title: string
  code: string
  url: string
}) => {
  const [status, setStatus] = useState<'loading' | 'loaded' | 'error'>(
    'loading'
  )
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    if (status !== 'loading') return
    const timeout = window.setTimeout(() => setStatus('error'), 20000)
    return () => window.clearTimeout(timeout)
  }, [status, attempt])
  return (
    <Mtds.Card as={Mtds.Grid} data-pad='4'>
      <Mtds.Heading as='h3' data-size='xs'>
        {title}
      </Mtds.Heading>
      {status === 'loading' && (
        <Mtds.Muted role='status'>
          Henter {title} fra bildetjenesten…
        </Mtds.Muted>
      )}
      {status === 'error' ? (
        <Mtds.Alert role='alert' data-color='danger'>
          Kunne ikke hente {title}. Kontroller nettverket eller prøv igjen.
          <Mtds.Flex>
            <Mtds.Button
              type='button'
              data-variant='secondary'
              onClick={() => {
                setAttempt(attempt + 1)
                setStatus('loading')
              }}
            >
              Prøv {title} igjen
            </Mtds.Button>
          </Mtds.Flex>
        </Mtds.Alert>
      ) : (
        <Mtds.Group
          data-color-scheme='light'
          data-pad='3'
          className={styles.imageBacking}
        >
          <img
            key={attempt}
            id={id}
            src={attempt ? `${url}&retry=${attempt}` : url}
            alt={`Generert ${title}`}
            className={styles.image}
            onLoad={() => setStatus('loaded')}
            onError={() => setStatus('error')}
          />
        </Mtds.Group>
      )}
      <Mtds.Field
        as='textarea'
        label={`Kodeinnhold for ${title}`}
        value={code}
        readOnly
      />
    </Mtds.Card>
  )
}
